import { QueryClient } from "@tanstack/react-query"
import { GetFinancialModelReportPresentationSlidesQueryParams } from "@/feature/report/api/types.ts"
import { getAllFinancialModelsQuery } from "@/feature/financial-model/api"

export const reportLoader =
  (
    queryClient: QueryClient,
    querySearchParams: Required<GetFinancialModelReportPresentationSlidesQueryParams>
  ) =>
  async () => {
    const financialModelV2WithSettings = await queryClient.ensureQueryData(
      getAllFinancialModelsQuery()
    )

    return {
      financialModelV2WithSettings,
      querySearchParams,
    }
  }
